module.exports = __webpack_public_path__ + "static/media/07.eb915940.jpg";